const TOKEN_KEY = 'cookdash-tokens';

export const getToken = () => localStorage.getItem(TOKEN_KEY) || '';

export const removeToken = () => localStorage.removeItem(TOKEN_KEY);

export const setToken = (tokens: string) =>
  localStorage.setItem(TOKEN_KEY, tokens);
